// extracted by mini-css-extract-plugin
export default {"action-panel":"action-panel_action-panel__fD+Bs"};